module.exports = __webpack_public_path__ + "static/leafletMap-bddf3c9e20a9d5bf097b3893b236d4a8.png";